import { render } from "./Extras.vue?vue&type=template&id=2ac32044&scoped=true"
import script from "./Extras.vue?vue&type=script&lang=js"
export * from "./Extras.vue?vue&type=script&lang=js"

import "./Extras.vue?vue&type=style&index=0&id=2ac32044&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ac32044"]])

export default __exports__